<template>
  <v-dialog v-model="dialog" persistent max-width="500px">
    <AcquirerForm v-if="dialog" :item="acquirerRecord" @close="close" />
  </v-dialog>
</template>

<script>
import AcquirerForm from "@/components/forms/AcquirerForm.vue";
export default {
  components: {
    AcquirerForm
  },
  props: {
    acquirerRecord: {
      type: Object,
      required: false,
      default() {
        return null;
      }
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    }
  },
  methods: {
    close(savedItem) {
      this.$emit("close", savedItem);
    }
  }
};
</script>

<style lang="scss" scoped></style>
